export default __webpack_public_path__ + "static/hw_ff_led-9f47f2039c7346057d82297f1082b217.png";